import React, { Component } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { GaleriaWrapper, Image, CloseGaleria, ImageWrapper, Slider, ForwardButton, BackButton } from './GaleriaElement';
import { getTranslatedKey } from '../../Utils/TranslateUtils';

export default class Galeria extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlide: this.props.index //variable indicando la slide del modal en la que estamos
    };
  }
  componentDidMount = () => {
    document.addEventListener('keydown', this.onArrowClick);
  };

  componentWillUnmount = () => {
    document.removeEventListener('keydown', this.onArrowClick);
  };

  onArrowClick = (e) => {
    if (e.key === 'ArrowRight' && this.state.currentSlide !== this.props.fotos.length - 1) {
      this.next();
    } else if (e.key === 'ArrowLeft' && this.state.currentSlide !== 0) {
      this.back();
    } else if (e.key === 'Escape') {
      this.props.toggleGaleria(false);
    }
  };
  // Función para pasar de página del modal
  next = () => {
    this.setState((state) => ({
      currentSlide: state.currentSlide + 1
    }));
  };

  back = () => {
    this.setState((state) => ({
      currentSlide: state.currentSlide - 1
    }));
  };
  // Función para actualizar la página actual del modal
  updateCurrentSlide = (index) => {
    const { currentSlide } = this.state;

    if (currentSlide !== index) {
      this.setState({
        currentSlide: index
      });
    }
  };

  renderImages = () => {
    this.props.fotos.map((foto) => {
      return (
        <ImageWrapper>
          <Image src={`${foto}`} alt="fotoinfo" />
        </ImageWrapper>
      );
    });
  };

  render() {
    return (
      <GaleriaWrapper>
        <CloseGaleria onClick={() => this.props.toggleGaleria(false)}>
          <svg
            title={getTranslatedKey('tancar')}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="#fff"
            class="sc-eHzXwO xqWNZ">
            <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"></path>
          </svg>
        </CloseGaleria>
        {this.state.currentSlide !== 0 && window.innerWidth > 768 ? (
          <BackButton title={getTranslatedKey('backButton')} onClick={this.back}>
            <svg xmlns="http://www.w3.org/2000/svg" id="backbutton" width="24" height="44" fill="white" x="0px" y="0px" viewBox="0 0 14.4 43.4">
              <path d="M13.9,42.8L5,21.9l9-21.1H9.8l-9,21.1l8.9,20.9H13.9z" />
            </svg>
          </BackButton>
        ) : null}
        {this.state.currentSlide !== this.props.fotos.length - 1 && window.innerWidth > 768 ? (
          <ForwardButton title={getTranslatedKey('forwardButton')} onClick={this.next}>
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="24" height="44" fill="white" x="0px" y="0px" viewBox="0 0 14.4 43.4">
              <path d="M4.7,42.8l8.9-20.9l-9-21.1H0.4l9,21.1L0.5,42.8H4.7z" />
            </svg>
          </ForwardButton>
        ) : null}
        <Slider id="Slider">
          <Carousel
            showStatus={false} // oculta el número que cuenta en que página del slide estamos
            showArrows={false} // oculta flechas laterales para moverse por el slide
            showThumbs={false} // oculta thumbnails del slider
            autoPlay={false} // cancela el autoplay
            dynamicHeight={false} // cancela el height dinámico y lo hace fijo
            selectedItem={this.state.currentSlide}
            onChange={this.updateCurrentSlide}
            renderIndicator={(onClickHandler, isSelected, index, label) => {
              const showIndicator = this.props.fotos.length > 1;

              const defStyle = {
                marginRight: 8,
                marginLeft: 8,
                fill: 'white',
                cursor: 'pointer',
                opacity: '100%',
                stroke: 'white',
                strokeWidth: '4px'
              };
              const style = isSelected ? { ...defStyle, fill: '#febf00' } : { ...defStyle };
              if (showIndicator) {
                return (
                  <span
                    style={style}
                    onClick={onClickHandler}
                    onKeyDown={onClickHandler}
                    value={index}
                    key={index}
                    role="button"
                    tabIndex={0}
                    aria-label={`${label} ${index + 1}`}>
                    {
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 56.7 56.7">
                        <circle cx="28.3" cy="28.3" r="27.8" />
                      </svg>
                    }
                  </span>
                );
              }
            }}
            {...this.props}>
            {this.props.fotos.map((foto) => {
              return (
                <ImageWrapper>
                  <Image src={`${foto}`} alt="fotoinfo" />
                </ImageWrapper>
              );
            })}
          </Carousel>
        </Slider>
      </GaleriaWrapper>
    );
  }
}
